import { FC, SyntheticEvent } from 'react';
import { GPTGameNameType, useGPTGameTrigger } from '../../games';
import { useGPTBanner } from '../store';
import { useIsBannerVisible } from '../hooks/useIsBannerVisible';
import { GPTBannerProps } from '../types';
import { GPT_BANNERS_CONFIG } from '../config';

export const GPTBannerHeadless = ({
  renderBanner,
  gameName,
  toShow = false,
}: {
  renderBanner: FC<GPTBannerProps>;
  gameName: GPTGameNameType;
  toShow?: boolean;
}) => {
  const { triggerGPTGame } = useGPTGameTrigger();
  const hideBanner = useGPTBanner((s) => s.hideBanner);
  const isVisible = useIsBannerVisible(gameName);

  if (!isVisible && !toShow) return null;

  const { Icon, title } = GPT_BANNERS_CONFIG[gameName] || {};

  const onClose = (e: SyntheticEvent) => {
    e.stopPropagation();
    hideBanner(gameName);
  };

  const onClick = () => {
    triggerGPTGame(gameName);
    hideBanner(gameName);
  };

  return renderBanner({ onClose, onClick, Icon, title, gameName });
};
